import { Component, ElementRef, Input, ViewChild } from '@angular/core';

import { ModalService } from 'src/app/components/modals/modal.service';

import { TimelineDescriptionService } from 'src/app/components/timeline/timeline-description.service';
import { PlaylistService } from '../../services/playlist.service';

@Component({
    selector: 'playlist',
    templateUrl: './playlist.component.html',
    styleUrls: ['./playlist.component.scss'],
    standalone: false
})
export class PlaylistComponent {

  @ViewChild('listElement') listElement: ElementRef<HTMLDivElement>;

  @Input() playlistItems: any;

  constructor(private modalService: ModalService,
    public playlistService: PlaylistService,
    public timelineDescription: TimelineDescriptionService) {
  }

  manage(playlistItem) {
    this.playlistService.editPlaylistItem(playlistItem);
  }

  remove(playlistItem, index: number) {
    const listScrollPosition = this.listElement.nativeElement.scrollTop;
    const itemElement = this.listElement.nativeElement.children[index];

    this.modalService.confirm('Remove Playlist Item?',
      'Are you sure you want to remove this item from the Playlist?',
      'Yes', 'No', 'removeButton'
    ).then(() => {
      this.playlistService.removePlaylistItem(playlistItem);
      this.listElement.nativeElement.scrollTo(0, listScrollPosition - itemElement.clientHeight);
      this.focusNextElementRemoveButton(itemElement as HTMLElement);
    })
    .catch(() => {
      const removeButton = itemElement.querySelector<HTMLButtonElement>('#removeButton');
      
      removeButton.focus();
      this.listElement.nativeElement.scrollTo(0, listScrollPosition);
    });
  }

  private focusNextElementRemoveButton(element: HTMLElement) {
    const focusedElement = element.nextElementSibling || element.previousElementSibling;
    if (focusedElement) {
      focusedElement.querySelector<HTMLButtonElement>('#removeButton').focus();
    }
  }

  sortItem(evt) {
    const oldIndex = evt.data.oldIndex;
    const newIndex = evt.data.newIndex;

    this.playlistService.moveItem(oldIndex, newIndex);
  }

  isAppleTVCompatible(playlistItem) {
    return this.playlistService.isItemAppleTVCompatible(playlistItem);
  }
}
